export default [
	{
		target: '#menu',
		content: 'Right here you can open the "side menu". It serves, on one side, as central access for global actions like exporting, creating or opening apps. On the other, app specific options are presented, such as the "App settings".'
	},
	{
		target: '#stream-app-controlbar',
		content: 'This is the "control panel" of your Stream App. Make sure to hit play to start your app. In the pause mode, it is possible to execute only one step at a time.'
	},
	{
		target: '#stream-app-controlbar',
		content: 'Further, you can enter the "view mode" to show your app without the edit tools. In addition, you are able to control the "cycle speed" of your App. If any of your sheets calculate continuously they do this with this "cycle speed".'
	},
	{
		target: '#stream-app-controlbar',
		content: 'Further, you can enter the "view mode" to show your app without the edit tools. In addition, you are able to control the "cycle speed" of your App. If any of your sheets calculate continuously they do this with this "cycle speed".'
	},
	{
		target: '#stream-app-edit-area',
		content: 'This is the edit area of your Stream App. It contains one or multiple Streamsheets and/or a Dashboard sheet.'
	},
	{
		target: '#stream-app-edit-area',
		content: 'In order to receive messages, a Streamsheet has an inbox that you can connect to data streams. As soon as you get your first message, drag and drop the items in the payload onto the sheet. This creates a reference to the stream which updates with every new message. Click the cogwheel to open the inbox settings. This is where you are able to set connected streams and the "Calculation Mode".'
	},
	{
		target: '#stream-app-edit-area',
		content: 'Next to the Inbox there is the "grid". The grid of a Streamsheet is the place where the logic for analyzing, processing and visualizing data is entered. With every new step, the whole sheet recalculates itself. All of your logic within the grid will be calculated one cell after another. The calculation starts from left to right and from top to bottom! (A1,B1,C1...A2) This is very important to remember, since the order of referenced cells can have various effects on your results.'
	},
	{
		target: '#stream-app-toolbar',
		content: 'This is the "toolbar" of your App. Use it for various actions, like format changes, accessing shapes & charts or reverting an action.'
	},
];



// WEBPACK FOOTER //
// ./src/tutorial/machine-steps.js